import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const assetsSchemaRoute: InvariantJiraRoute = {
	name: 'assets-schema',
	path: '/jira/assets/object-schema/:objectSchemaId',
};
